<script>
import { defineComponent } from 'vue'
import radio from "@/component/helper/form/radio.vue";
import ic_comptable from "@icon/ic_comptable.svg";
import ic_openL from "@icon/ic_openL.svg";
import icKa from "@icon/ic-ka.svg";

export default defineComponent({
  name: "RequestLists",
  components: { radio },
  props: {
    oneRequest: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  emits: ["openDetail", "showCompanyDetails"],

  data() {
    return {
      icons: { ic_comptable, icKa, ic_openL }
    }
  },
  methods: {
    truncateText(text, maxLength, suffix = '...') {
      if (!text || text.length <= maxLength) {
        return text
      }
      return text.slice(0, maxLength) + suffix
    },

    // ✅ Fonction pour ouvrir les détails de la demande
    openDetail() {
      if (this.oneRequest.request.state === 'TREATED') {
        console.log('treate')
      } else {
        this.$emit('openDetail');
      }
    },

    // ✅ Fonction pour afficher les détails de l'entreprise (clic sur l'icône openL)
    showCompanyDetails(event) {
      event.stopPropagation(); // Empêche la propagation vers openDetail
      this.$emit('showCompanyDetails');
    }
  }
})
</script>

<template>
  <div class="RequestLists">
    <div
      class="border-b BorderColor w-full flex items-center px-5 h-20 cursor-pointer gap-2"
      @click="openDetail"
    >
      <div class="w-1/2 flex justify-start items-center gap-5">
        <radio @click.stop />
        <div class="flex items-center gap-2">
          <icon
            :data="icons.icKa"
            height="32"
            width="32"
            class="w-8 h-8"
            original
          />
          {{ oneRequest.company.fullName }}
          <!-- ✅ Clic sur cette icône => détails de l'entreprise -->
          <icon
            :data="icons.ic_openL"
            height="16"
            width="16"
            class="w-4 h-4 cursor-pointer"
            original
            @click="showCompanyDetails"
          />
        </div>
      </div>

      <div class="w-1/2 flex justify-start items-center gap-5">
        <div class="flex items-center gap-3">
          <icon
            :data="icons.ic_comptable"
            height="20"
            width="20"
            class="w-5 h-5"
            original
          />
          {{ oneRequest.request.clientChoice.firstName + ' ' + oneRequest.request.clientChoice.lastName }}
        </div>
      </div>
      <!--  comptable affecté -->
      <!-- <div class="w-1/2 flex justify-start items-center gap-5">
        <div class="flex items-center gap-3">
          <icon
            :data="icons.ic_comptable"
            height="20"
            width="20"
            class="w-5 h-5"
            original
          />
          {{ oneRequest.request.clientChoice.firstName + ' ' + oneRequest.request.clientChoice.lastName }}
        </div>
      </div> -->

      <div class="w-1/3 flex justify-start">
        {{ new Date(oneRequest.request.created_at).toLocaleDateString() }}
      </div>

      <div class="w-1/3 flex justify-start">
        {{ new Date(oneRequest.request.clientChoice.created_at).toLocaleDateString() }}
      </div>

      <div class="w-1/3 Email responsive-large flex justify-start items-center gap-3">
        <div
          v-if="oneRequest.request.state === 'WAITING'"
          class="text-sm textGray mr-10"
        >
          En attente
        </div>
        <div
          v-if="oneRequest.request.state === 'WAITING'"
          class="wait text-white px-7 py-2 rounded-100"
        >
          Traiter
        </div>
        <div
          v-if="oneRequest.request.state === 'REJECTED'"
          class="px- py-2 rounded-100 BGColorReject"
        >
          Rejeté
        </div>
        <div
          v-if="oneRequest.request.state === 'TREATED'"
          class="finish px- py-2 rounded-100"
        >
          Traité
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@media (max-width: 1600px) {
  .WidthContain {
    font-size: 14px;
  }
}

.wait {
  background-color: #466AFA;
}

.finish {
  color: #31B049;
}

.BGColorReject {
  color: #F04C36;
}
.textGray {
  color: rgb(235, 151, 5);
}

</style>
